/**
 * useSiteDevices — device roster from config.site_devices via
 * GET /api/v1/sites/:id/devices.
 *
 * Since djin-cloud#625 its only consumer on the Alarms tab is QuietDeviceStrip,
 * which lists devices with no active alarms. It is deliberately NOT structural:
 * alarm grouping derives from block_id/device_id on the alarm rows themselves,
 * so a failing roster call costs the quiet strip and nothing else. The previous
 * AlarmTree gated the whole page on this query and silently flattened when it
 * failed — see #624.
 */

import { useQuery } from '@tanstack/react-query';
import { alarmsApi } from '../services/alarmsApi';

export function useSiteDevices(siteId: string) {
  return useQuery({
    queryKey: ['site-devices', siteId],
    queryFn: () => alarmsApi.listDevices(siteId),
    staleTime: 60_000,
    enabled: !!siteId,
  });
}
